import { ref } from 'vue';

import { defineStore } from 'pinia';

import { TypeBrand, TypeTheme } from '@/types/common';

export const useThemeStore = defineStore(
  'theme',
  () => {
    /* states */
    const brand = ref<TypeBrand>('sconchat');
    const theme = ref<TypeTheme>('light');

    const isDirtyBrand = ref<boolean>(false);
    const isDirtyTheme = ref<boolean>(false);

    /* actions */
    const updateBrand = (data: TypeBrand, byUser: boolean = false) => {
      if ((!isDirtyBrand.value || byUser) && ['sconchat'].includes(data)) {
        brand.value = data;
        document.documentElement.setAttribute('data-brand', data);
      }
      if (byUser) {
        isDirtyBrand.value = true;
      }

      const brandData = data ? brand.value : 'sconchat';
      document.documentElement.setAttribute('data-brand', brandData);
    };

    const updateTheme = (data: TypeTheme, byUser: boolean = false) => {
      if ((!isDirtyTheme.value || byUser) && ['light', 'dark'].includes(data)) {
        theme.value = data;
      }
      if (byUser) {
        isDirtyTheme.value = true;
      }

      const themeData = data ? theme.value : 'light';
      document.documentElement.setAttribute('data-theme', themeData);
    };

    return {
      /* states */
      brand, // 브랜드
      theme, // 테마
      isDirtyBrand, // 사용자 변경 유무
      isDirtyTheme, // 사용자 변경 유무
      /* actions */
      updateBrand, // 브랜드 업데이트
      updateTheme, // 테마 업데이트
    };
  },
  { persist: true }
);
